import { env } from '@polleverywhere/core'
import store from '@polleverywhere/redux'
import { slice as appSlice } from '../slices/app'
import URI from 'urijs'

export async function authCodeRedirect ({ initialSignup = false, signupEnabled = true, reason = '', usrc = 'signup_api' } = {}) {
  store.dispatch(appSlice.markRedirecting())
  const urlBase = env.get('nginx_proxy_path') === '/proxy' ? URI('/proxy/') : env.get('api_url')
  window.location = urlBase.segment('/sessions/required').search({ redirect: window.location, usrc: usrc, initial_signup: initialSignup, signup_enabled: signupEnabled, reason: reason }).toString()
}
